import { useFromInput } from '@ui/features/Trade/hooks/useFromInput';
import BigNumber from 'bignumber.js';

import { useTotalOpenPositionFee } from './useTotalOpenPositionFee';

export const useEstimatedCollateralUsd = () => {
  const totalOpenPositionFee = useTotalOpenPositionFee({
    // gas fee should not be included for estimate due to gas fee will be deduct from user wallet, included will impact on est PnL
    isGasFeeIncluded: false,
  });
  const inputUsd = useFromInput((s) => s.input).value.usd; // fromUsd

  return inputUsd?.minus(totalOpenPositionFee?.final ?? BigNumber(0)); // live price included, no need memo
};